import { combineReducers } from 'redux';

import demographics from './demographicsreport/reducer';

export default combineReducers({
  demographics,
});



// WEBPACK FOOTER //
// ./src/pages/demographics/state/reducer.js